import { observable } from 'mobx';

class PremiumSessionDashboardStore {
  @observable data: Record<string, unknown> | undefined = undefined;

  @observable userSubscription: Record<string, unknown> = {};
}

export default PremiumSessionDashboardStore;
